document.addEventListener('DOMContentLoaded', () => {
    const accordions = document.querySelectorAll('.block--rusvm-accordion .rusvm-accordion');

    accordions.forEach(accordion => {
        const accordionId = accordion.getAttribute('data-accordion-id');
        const panels = accordion.querySelectorAll('.rusvm-accordion-collapse');

        panels.forEach(panel => {
            // Wire each panel to close others in the same accordion
            panel.setAttribute('data-bs-parent', `#${accordionId}`);

            bootstrap.Collapse.getOrCreateInstance(panel, { toggle: false });
        });
    });
});
